<svg-icon key="lockSmall" fontSize="14px"></svg-icon>
<span class="locked-text">
  {{ "global.locked_by" | translate }}: {{ lockedBy?.name }}
  {{ lockedAt | amTimeAgo }}
</span>
